import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

const useSubsidys = (userId) => {
  const { data: subsidys, ...queryResponse } = useQuery({
    queryKey: ["subsidys", userId],
    queryFn: () => api.opekepe.fetchSubsidyData(userId),
  });
  const { fetchState } = useFetchStateHelper(queryResponse);

  return { subsidys, fetchState };
};

export { useSubsidys };
